module.exports = __webpack_public_path__ + "img/memberReport_doctor.9dfce259.svg";